export enum AppEvent {
  CHANGE_LANGUAGE = "CHANGE_LANGUAGE",
  LOGOUT = "LOGOUT",
  UPDATE_MICRO_APP_PROPS = "UPDATE_MICRO_APP_PROPS",
}
